import { InappPurchasesProvider } from "providers/inapp-purchases.provider"

import { AnalyticProvider } from "./analytic.provider"
import { BlogProvider } from "./blog.provider"
import { GlobalProvider } from "./global.provider"
import { SearchProvider } from "./search.provider"
import { SubscriptionProvider } from "./subscription.provider"
import { MediaProvider } from "./media.provider"
import { PaymentTipsProvider } from "./payment-tips.provider"
import { ContactUsProvider } from "./contact-us.provider"
import { HuaweiTipsProvider } from "./huawei-tips.provider"
import { VacanciesProvider } from "./vacancies.provider"
import { DepartmentsProvider } from "./departments.provider"
import { AndroidPaymentsProvider } from "./android-payments.provider"
import { LegalProvider } from "./legal.provider"
import { TeamPageProvider } from "./team-page.provider"
import { GDPRProvider } from "./gdpr.provider"

export class AppProvider {
  AnalyticProvider!: AnalyticProvider
  BlogProvider!: BlogProvider
  GlobalProvider!: GlobalProvider
  SearchProvider!: SearchProvider
  SubscriptionProvider!: SubscriptionProvider
  MediaProvider!: MediaProvider
  PaymentTipsProvider!: PaymentTipsProvider
  InappPurchasesProvider!: InappPurchasesProvider
  ContactUsProvider!: ContactUsProvider
  HuaweiTipsProvider!: HuaweiTipsProvider
  VacanciesProvider!: VacanciesProvider
  DepartmentsProvider!: DepartmentsProvider
  AndroidPaymentsProvider!: AndroidPaymentsProvider
  LegalProvider!: LegalProvider
  TeamPageProvider!: TeamPageProvider
  GDPRProvider!: GDPRProvider

  init() {
    const globalProvider = new GlobalProvider()
    const analyticProvider = new AnalyticProvider()
    const blogProvider = new BlogProvider()
    const subscriptionProvider = new SubscriptionProvider()
    const searchProvider = new SearchProvider()
    const mediaProvider = new MediaProvider()
    const paymentTipsProvider = new PaymentTipsProvider()
    const inappPurchasesProvider = new InappPurchasesProvider()
    const contactUsProvider = new ContactUsProvider()
    const huaweiTipsProvider = new HuaweiTipsProvider()
    const vacanciesProvider = new VacanciesProvider()
    const departmentsProvider = new DepartmentsProvider()
    const androidPaymentsProvider = new AndroidPaymentsProvider()
    const legalProvider = new LegalProvider()
    const teamPageProvider = new TeamPageProvider()
    const gdprProvider = new GDPRProvider()

    const ctx = {
      GlobalProvider: globalProvider,
      AnalyticProvider: analyticProvider,
      BlogProvider: blogProvider,
      SubscriptionProvider: subscriptionProvider,
      SearchProvider: searchProvider,
      MediaProvider: mediaProvider,
      PaymentTipsProvider: paymentTipsProvider,
      InappPurchasesProvider: inappPurchasesProvider,
      ContactUsProvider: contactUsProvider,
      HuaweiTipsProvider: huaweiTipsProvider,
      VacanciesProvider: vacanciesProvider,
      DepartmentsProvider: departmentsProvider,
      AndroidPaymentsProvider: androidPaymentsProvider,
      LegalProvider: legalProvider,
      TeamPageProvider: teamPageProvider,
      GDPRProvider: gdprProvider,
    }

    // @ts-ignore
    globalProvider.setProviders(ctx)
    // @ts-ignore
    analyticProvider.setProviders(ctx)
    // @ts-ignore
    blogProvider.setProviders(ctx)
    // @ts-ignore
    subscriptionProvider.setProviders(ctx)
    // @ts-ignore
    searchProvider.setProviders(ctx)
    // @ts-ignore
    mediaProvider.setProviders(ctx)
    // @ts-ignore
    paymentTipsProvider.setProviders(ctx)
    // @ts-ignore
    inappPurchasesProvider.setProviders(ctx)
    // @ts-ignore
    contactUsProvider.setProviders(ctx)
    // @ts-ignore
    huaweiTipsProvider.setProviders(ctx)
    // @ts-ignore
    vacanciesProvider.setProviders(ctx)
    // @ts-ignore
    departmentsProvider.setProviders(ctx)
    // @ts-ignore
    androidPaymentsProvider.setProviders(ctx)
    // @ts-ignore
    legalProvider.setProviders(ctx)
    // @ts-ignore
    teamPageProvider.setProviders(ctx)
    // @ts-ignore
    gdprProvider.setProviders(ctx)

    this.GlobalProvider = globalProvider
    this.AnalyticProvider = analyticProvider
    this.BlogProvider = blogProvider
    this.SubscriptionProvider = subscriptionProvider
    this.SearchProvider = searchProvider
    this.MediaProvider = mediaProvider
    this.PaymentTipsProvider = paymentTipsProvider
    this.InappPurchasesProvider = inappPurchasesProvider
    this.ContactUsProvider = contactUsProvider
    this.HuaweiTipsProvider = huaweiTipsProvider
    this.VacanciesProvider = vacanciesProvider
    this.DepartmentsProvider = departmentsProvider
    this.AndroidPaymentsProvider = androidPaymentsProvider
    this.LegalProvider = legalProvider
    this.TeamPageProvider = teamPageProvider
    this.GDPRProvider = gdprProvider
  }
}
